// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".azati-vwc-input-validation-message .error-message{font-family:Poppins,Verdana,sans-serif;font-size:12px;color:#f50000;font-weight:600}", ""]);
// Exports
module.exports = exports;
